import React, { FC } from "react"
import { IconDown, SectionHeader, SectionHeaderProps } from "dash-styled"

export const CollapsibleSectionHeader: FC<{
    isOpen: boolean
    separator: boolean
    testId?: string
    titleTestId?: string
    headerComponent?: SectionHeaderProps["component"]
    onToggle?: () => void
}> = ({
    isOpen,
    separator,
    testId,
    titleTestId,
    headerComponent = "h3",
    onToggle,
    children
}) => {
    return (
        <div
            className={`${onToggle === undefined ? "" : "cursor-pointer"} flex`}
            onClick={onToggle}
            data-testid={testId}
        >
            <IconDown
                className={`transform duration-300 ${
                    isOpen ? "" : "-rotate-90"
                } mt-1 mr-2 text-smoke-800`}
                size="xs"
            />
            <SectionHeader
                className="flex-grow"
                component={headerComponent}
                variant="heading3"
                testId={titleTestId}
                showSeparator={isOpen && separator}
            >
                {children}
            </SectionHeader>
        </div>
    )
}
